import titleLink from '@components/ui-components/title-link/component.js'
import reviewsItem from '@components/ui-components/reviews-item/component.js'

export default {
  components: {
    'title-link-cmp': titleLink,
    'reviews-item-cmp': reviewsItem,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/reviews/component.js